import TextField from "@mui/material/TextField";
import { blue } from "@mui/material/colors";
import FormLabel from "@mui/material/FormLabel";
import { Params } from "../../../interfaces/interfaces";

type Props = {
  params: Params;
  handleChange: <P extends keyof Params>(prop: P, value: Params[P]) => void;
};

export function CashierTextField({ params, handleChange }: Props) {
  return (
    <>
      <FormLabel>Cashier URL</FormLabel>
      <TextField
        type="text"
        name="cashierURL"
        value={params.cashierURL}
        onChange={(e) => {
          handleChange("cashierURL", e.target.value);
        }}
        spellCheck="false"
        sx={{
          "& fieldset": {
            borderColor: blue[800],
          },
          "&:hover": {
            "&& fieldset": {
              border: "1px solid white",
            },
          },
        }}
      />
    </>
  );
}
